import React from 'react';

// Utilità condivise dalla pagina Campagne e dalle sue sezioni admin.

export { msgErrore } from '../utils/formati';   // un solo punto, riesportata per le pagine Campagne

// null = dato non disponibile (n.d.), mai 0
const ND = <span title="Dato non disponibile" style={{ color: '#a0aec0' }}>n.d.</span>;
export const fmtEur = v => (v === null || v === undefined) ? ND
  : v.toLocaleString('it-IT', { style: 'currency', currency: 'EUR' });
export const fmtN = (v, dec = 0) => (v === null || v === undefined) ? ND
  : v.toLocaleString('it-IT', { minimumFractionDigits: dec, maximumFractionDigits: dec });
export const fmtPerc = v => (v === null || v === undefined) ? ND
  : (v * 100).toLocaleString('it-IT', { maximumFractionDigits: 1 }) + '%';
// "—" = divisore a zero (spesa senza lead, lead senza adesioni) o spesa a zero (CPL e costo per adesione,
// mai 0,00 €): il dato c'è, il rapporto no. Il motivo arriva dal backend in r.vuoti (campo -> codice),
// stessi testi di report.MOTIVI.
export const MOTIVI = { nessun_lead: 'nessun lead nel periodo', nessuna_adesione: 'nessuna adesione nel periodo',
  nessuna_spesa: 'nessuna spesa registrata nel periodo' };
export function Rapporto({ r, campo, fmt }) {
  const motivo = r.vuoti?.[campo];
  if (motivo) return <span title={MOTIVI[motivo] || motivo} style={{ color: '#718096' }}>—</span>;
  return fmt(r[campo] ?? null);
}
export const fmtData = iso => iso ? new Date(iso.length === 10 ? iso + 'T00:00:00' : iso)
  .toLocaleDateString('it-IT') : '';
export const fmtDataOra = iso => iso ? new Date(iso).toLocaleString('it-IT', { dateStyle: 'short', timeStyle: 'short' }) : '';

export function Sezione({ titolo, colore, destra, children }) {
  return (
    <div style={{ marginBottom: 24 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center',
        borderBottom: `2px solid ${colore}30`, paddingBottom: 6, marginBottom: 12 }}>
        <div style={{ fontSize: 11, fontWeight: 700, color: colore, textTransform: 'uppercase', letterSpacing: '0.8px' }}>
          {titolo}
        </div>
        {destra}
      </div>
      {children}
    </div>
  );
}

export const card = { background: 'white', border: '1px solid #e8eaed', borderRadius: 10, padding: '14px 16px' };
export const th = { textAlign: 'right', padding: '6px 8px', fontSize: 11, color: '#718096', fontWeight: 600,
  textTransform: 'uppercase', letterSpacing: '0.4px', borderBottom: '1px solid #e8eaed', whiteSpace: 'nowrap' };
export const thSx = { ...th, textAlign: 'left' };
export const td = { textAlign: 'right', padding: '6px 8px', fontSize: 13, borderBottom: '1px solid #f1f3f5', whiteSpace: 'nowrap' };
export const tdSx = { ...td, textAlign: 'left', whiteSpace: 'normal' };
export const pulsante = (principale, disabilitato) => ({
  display: 'inline-flex', alignItems: 'center', gap: 5, padding: '6px 12px', borderRadius: 6, fontSize: 13,
  fontWeight: 600, cursor: disabilitato ? 'not-allowed' : 'pointer', opacity: disabilitato ? 0.5 : 1,
  border: principale ? '1px solid #2B6CB0' : '1px solid #d6d3d1',
  background: principale ? '#2B6CB0' : 'white', color: principale ? 'white' : '#1A1A2E',
});
export const errore = { color: '#C53030', fontSize: 13, margin: '6px 0' };

// Testo di un Blob (FileReader: funziona anche dove Blob.text() manca)
export function testoBlob(b) {
  return new Promise((ok, ko) => {
    const r = new FileReader();
    r.onload = () => ok(r.result);
    r.onerror = () => ko(r.error);
    r.readAsText(b);
  });
}

// Tendine dei canali: una voce per canale, con il prefisso principale (migrazione 032: per Meta Ads
// è META, non anche Facebook); un canale senza principale usa il suo primo prefisso.
export function vociCanale(prefissi, filtro = () => true) {
  const voci = new Map();
  for (const p of (prefissi || []).filter(filtro)) {
    const v = voci.get(p.canale);
    if (!v || (p.principale && !v.principale)) voci.set(p.canale, p);
  }
  return [...voci.values()];
}
// valore della tendina per un prefisso salvato: la voce del suo canale (anche se è un prefisso secondario)
export function voceCanale(prefissi, prefisso) {
  const p = (prefissi || []).find(x => x.prefisso === prefisso);
  const v = p && vociCanale(prefissi).find(x => x.canale === p.canale);
  return v ? v.prefisso : (prefisso || '');
}

// Etichetta del tipo per i menu: "senza tipo, deciso" e "da decidere" sono due scelte distinte
export const SENZA_TIPO = 'senza_tipo';
export function valoreTipo(tipoId, senzaTipoDeciso) {
  if (tipoId) return String(tipoId);
  return senzaTipoDeciso ? SENZA_TIPO : '';
}
export function SelectTipo({ tipi, value, onChange, disabled }) {
  return (
    <select className="input-filtro" value={value} onChange={e => onChange(e.target.value)} disabled={disabled}
      style={{ minWidth: 200 }}>
      <option value="">— da decidere —</option>
      <option value={SENZA_TIPO}>— senza tipo, deciso —</option>
      {(tipi || []).map(t => <option key={t.id} value={t.id}>{t.nome}</option>)}
    </select>
  );
}
export function corpoTipo(valore) {
  if (valore === SENZA_TIPO) return { tipo_ricorso_id: null, senza_tipo_deciso: true };
  return { tipo_ricorso_id: valore ? Number(valore) : null, senza_tipo_deciso: false };
}
